(function () {
	'use strict';
	angular.module('app.supplyChain', ['ui.bootstrap', 'ui.select', 'pascalprecht.translate']);
})();
